module.exports = __webpack_public_path__ + "img/plano-matriz-mic-mac.4673da28.png";